import React from "react";
import Header from "./components/Header";
import Hero from "./components/Hero";
import WhyBSquare from "./components/WhyBSquare";
import WhoWeServe from "./components/WhoWeServe";
import Services from "./components/Services";
import MortgageRenewal from "./components/MortgageRenewal";
import About from "./components/About";
import Approach from "./components/Approach";
import Founder from "./components/Founder";
import InsuranceProviders from "./components/InsuranceProviders";
import CTA from "./components/CTA";
import Footer from "./components/Footer";
import "./App.css";

function App() {
  return (
    <div className="App">
      <Header />
      <Hero />
      <WhyBSquare />
      <WhoWeServe />
      <Services />
      <MortgageRenewal />
      <About />
      <Approach />
      <Founder />
      <InsuranceProviders />
      <CTA />
      <Footer />
    </div>
  );
}

export default App;
